import { useLocation } from 'react-router-dom';
import { useRole, Role } from 'hooks/common/useRole';
import { Pages } from './SidebarMenu.pages';
import SidebarLink from './components/SidebarLink';
import LogoutButton from './components/LogoutButton';
import styles from './SidebarMenu.module.css';
import LoginUser from './components/LoginUser';

const SidebarMenu = (): JSX.Element => {
  const { role } = useRole();
  const { pathname } = useLocation();

  return (
    <div className={styles.container}>
      <div className={styles.links}>
        <ul className={styles.links__list}>
          {Pages.filter((page: Pages) => page.permittedRoles.includes(role as Role)).map(
            (page, index) => {
              const PageComponent = page.component;
              return !!PageComponent ? (
                <PageComponent key={index} link={page.path} />
              ) : (
                <li key={index}>
                  <SidebarLink
                    active={pathname.startsWith(page.path[0])}
                    icon={page.icon}
                    to={page.path[0]}
                  >
                    {page.title}
                  </SidebarLink>
                </li>
              );
            },
          )}
        </ul>

        <div className={styles.logout}>
          <LoginUser />
          <LogoutButton />
        </div>
      </div>
    </div>
  );
};
export default SidebarMenu;
